import React from 'react';

import TemplateManagementListPanel from '@totem/components/ticketing/templateManagement/list/TemplateListPanel';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const TemplateManagementListPage = () => {
  return (
    <ContentLayout>
      <TemplateManagementListPanel />
    </ContentLayout>
  );
};

export default TemplateManagementListPage;
